import { render, staticRenderFns } from "./NakaTags.vue?vue&type=template&id=40fe312c&"
import script from "./NakaTags.vue?vue&type=script&lang=ts&"
export * from "./NakaTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports